
import React from 'react';

// Componente Features
interface FeatureProps {
  icon: string;
  title: string;
  desc: string;
}

const Feature: React.FC<FeatureProps> = ({ icon, title, desc }) => (
  <div className="flex gap-5">
    <div className="flex-shrink-0 w-10 h-10 bg-medical/5 text-medical rounded-xl flex items-center justify-center text-lg">
      <i className={icon}></i>
    </div>
    <div>
      <h4 className="text-md font-black text-dark mb-1">{title}</h4>
      <p className="text-xs text-gray-500 font-medium leading-relaxed">{desc}</p>
    </div>
  </div>
);

const Features: React.FC = () => {
  return (
    <section id="caracteristicas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl font-black text-medical mb-8">
              Diferenciadores clave para su práctica profesional
            </h2>
            <div className="grid sm:grid-cols-2 gap-x-10 gap-y-12">
              <Feature 
                icon="fas fa-globe"
                title="Datos Portables y Abiertos"
                desc="Sus datos oncológicos son suyos. Sin formatos propietarios, interoperables con otros sistemas de salud."
              />
              <Feature 
                icon="fas fa-book-medical"
                title="Biblioteca de Protocolos"
                desc="330+ fármacos y protocolos precargados. Capacidad para modificar esquemas o crear sus propios protocolos desde cero."
              />
              <Feature 
                icon="fas fa-bolt"
                title="Implementación Inmediata"
                desc="Solo requiere la creación de su clínica y usuarios para comenzar. Despliegue en minutos, no en meses."
              />
              <Feature 
                icon="fas fa-mobile-alt"
                title="Acceso Multiplataforma"
                desc="Enfermería administra desde computadoras o tablets con trazabilidad total en tiempo real bajo mCODE."
              />
              <Feature 
                icon="fas fa-users-gear"
                title="Capacitación Directa"
                desc="Sesión intensiva para todo el equipo clínico (Médicos, Farmacia, Enfermería) para asegurar el éxito del flujo."
              />
              <Feature 
                icon="fas fa-comment-dots"
                title="Soporte Especializado"
                desc="Interfaz y soporte técnico 100% en español por expertos que entienden la terminología oncológica."
              />
            </div>
          </div>
          
          <div className="bg-medical rounded-[3rem] p-12 text-white relative overflow-hidden shadow-2xl">
            <div className="absolute top-0 right-0 opacity-10 pointer-events-none translate-x-1/4 -translate-y-1/4">
              <i className="fas fa-fire text-[300px]"></i>
            </div>
            <h3 className="text-2xl font-black mb-8 relative z-10">Desarrollado por un Equipo Multidisciplinario</h3>
            <div className="space-y-6 relative z-10">
              <div className="flex items-center gap-4 bg-white/10 p-4 rounded-2xl border border-white/10 backdrop-blur-sm">
                <i className="fas fa-user-md text-2xl text-fhir"></i>
                <span className="font-bold text-sm leading-tight">Oncólogos Médicos validando flujos clínicos reales</span>
              </div>
              <div className="flex items-center gap-4 bg-white/10 p-4 rounded-2xl border border-white/10 backdrop-blur-sm">
                <i className="fas fa-pills text-2xl text-onco"></i>
                <span className="font-bold text-sm leading-tight">Farmacéuticos aplicando estándares HOPA/ASCO en mezclas</span>
              </div>
              <div className="flex items-center gap-4 bg-white/10 p-4 rounded-2xl border border-white/10 backdrop-blur-sm">
                <i className="fas fa-code text-2xl text-blue-300"></i>
                <span className="font-bold text-sm leading-tight">Arquitectos de Software expertos en HL7 FHIR e Interoperabilidad</span>
              </div>
            </div>
            <div className="mt-10 pt-10 border-t border-white/10">
              <p className="text-xs font-bold text-blue-100 uppercase tracking-widest mb-4">Ideal para:</p>
              <div className="text-3xl font-black text-fhir italic leading-tight">Prácticas de Oncología <br/><span className="text-xl not-italic font-bold">Pequeñas y Medianas</span></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
